import { render, staticRenderFns } from "./Sm400Black.vue?vue&type=template&id=06f1478e&scoped=true&"
var script = {}
import style0 from "./Sm400Black.vue?vue&type=style&index=0&id=06f1478e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1478e",
  null
  
)

export default component.exports